var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77614 15.6724L7.57552 19.6532L3.87717 22.463L0 15.6282L8.09072 1.53711L11.8788 4.13727L12.0037 8.35203L11.9679 8.37261L7.77614 15.6724Z",
    fill: "#28B446"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09058 1.53711L10.3929 11.1153L12.0035 8.35203L11.8786 2.80386L8.09058 1.53711Z",
    fill: "#219B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9085 1.53711L23.9999 15.6282L19.6366 17.8349L16.1813 15.6493V15.6282L12.0035 8.35203L8.09058 1.53711H15.9085Z",
    fill: "#FFD837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.6289L20.1253 22.4195L3.8772 22.4638L7.77617 15.6732L16.1815 15.6501L24 15.6289Z",
    fill: "#518EF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8772 22.4627L10.6758 15.6641L7.77617 15.672L3.8772 22.4627Z",
    fill: "#3A5BBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.6272L15.1294 13.7949L16.1815 15.6484L24 15.6272Z",
    fill: "#FBBB00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/googleDrive.bd27ae15.svg";
export { ForwardRef as ReactComponent };